import React from 'react'

import { Avatar } from 'widgets/Avatar'
import { Box } from 'widgets/Box'
import { Text } from 'widgets/Text'

import { UserType } from 'types/user'

export interface UserRowProps {
  user: UserType
  sessionsCompletedCount?: number
}

export const BaseUserRow = ({ user, sessionsCompletedCount }: UserRowProps) => {
  return (
    <Box flexDirection='row'>
      <Box padding='md'>
        <Avatar width={64} height={64} image={user?.avatar} />
      </Box>
      <Box
        margin={{ top: 'md', right: 'lg' }}
        flex={6}
        flexDirection='column'
        justifyContent='flex-start'
      >
        <Text fontWeight='semiBold' fontSize='sm'>
          {user.firstName} {user.lastName}{' '}
          <Text fontSize='xs' color='greyDarker'>
            @{user.username}
          </Text>
        </Text>
        <Text numberOfLines={2} color='greyDarkest' fontSize='sm'>
          {user.bio ??
            `Follow ${user.firstName} ${user.lastName} for free or subscribe to get access to all their content.`}
        </Text>
      </Box>
    </Box>
  )
}
